import { Component } from '@angular/core';
import { LogData, LogEntry } from '../../../../../../../shared/interfaces/core-logs.interface';
import { CaseService } from '../../../../../services/case.services';
import { TranslateService } from '@ngx-translate/core';

interface TimelineFilters {
  users: string[];
  selectedUsers: string[];
  matchedUsers: number;
  actions: string[];
  selectedActions: string[];
  matchedActions: number;
}

@Component({
  selector: 'app-case-timeline',

  templateUrl: './case-timeline.component.html',
  styleUrl: './case-timeline.component.scss',
})
export class CaseTimelineComponent {

  isVisible = false;
  data: LogData;
  fullDataLogs: LogEntry[] = [];

  filters: TimelineFilters = this.emptyFilters();

  constructor(private readonly caseService: CaseService, private readonly translate: TranslateService) {}

  open(sourceId: number,  type: 'case' | 'appointment' | 'patient' | 'patient_file' = 'case', createLog?: { user: { firstName: string, lastName: string}, date: Date}) {
    const firstLog = createLog ? [{
      id: -1,
      date: new Date(createLog.date),
      action: this.translate.instant('definition.patient.log-created'),
      changes: [],
      user: createLog.user
    }] : [];
    this.caseService.getLogs(sourceId.toString(), type).subscribe((res) => {
      this.isVisible = true;
      this.data = res ?? this.getEmptyLogData();
      this.filters = this.emptyFilters();
      const resLogs = res?.logs ? res.logs : [];
      this.fullDataLogs = [...resLogs, ...firstLog].map((r, i) => {
        this.checkAndAddFilter(r, this.filters);
        return {
          ...r,
          index: this.fullDataLogs.length - i,
        };
      });
      this.data.logs = [...this.fullDataLogs];
      this.updateData();
    });
  }

  private emptyFilters(): TimelineFilters {
    return {
      users: [],
      selectedUsers: [],
      matchedUsers: 0,
      actions: [],
      selectedActions: [],
      matchedActions: 0,
    }
  }

  private getEmptyLogData() {
    return {
      id: -1,
      type: '',
      sourceId: '',
      logs: []
    }
  }

  private checkAndAddFilter(value: LogEntry, filterArray: TimelineFilters) {
    if(!filterArray.actions.includes(value.action)) {
      filterArray.actions.push(value.action);
    }
    const userName = `${value.user.firstName} ${value.user.lastName}`;
    if(!filterArray.users.includes(userName)) {
      filterArray.users.push(userName);
    }
  }

  updateData() {
    this.filters.matchedActions = 0;
    this.filters.matchedUsers = 0;
    this.data.logs = [...this.fullDataLogs].filter((log) => {
      const actionMatch = this.filters.selectedActions.length === 0 || this.filters.selectedActions.includes(log.action);
      const userMatch = this.filters.selectedUsers.length === 0 || this.filters.selectedUsers.includes(`${log.user.firstName} ${log.user.lastName}`);
      this.filters.matchedActions += actionMatch ? 1 : 0;
      this.filters.matchedUsers += userMatch ? 1 : 0;
      return actionMatch && userMatch;
    });
  }

  close() {
    this.isVisible = false;
  }
}
